export default "__VITE_ASSET__3dec86f3__"